import { render, staticRenderFns } from "./cuisineStatistics.vue?vue&type=template&id=11b7a928&"
import script from "./cuisineStatistics.vue?vue&type=script&lang=ts&"
export * from "./cuisineStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports